import { marketAppIntegrations } from "@/dictionaries/dictionary"

const openAndScrollToElement = (integration) => {
	if(!integration) return
	const intObj = marketAppIntegrations.find(obj => obj.panelId === integration)
	if(!intObj) return
	const el = document.getElementById(intObj.panelId)
	if(!el) return
	el.previousElementSibling?.click()
	setTimeout(() => {
		el.scrollIntoView({ behavior: 'smooth' })
	}, 50)
}

export { openAndScrollToElement }

